import type { ReactNode } from 'react'
import type { UseFormReturn } from 'react-hook-form'

import { MarkdownEditor } from '@/components/organisms/markdown-editor/markdown-editor.organism'
import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form'

import type { AgencyFormSchemaType } from './agency-form.schema'

interface AgencyFormSystemTabProps {
  form: UseFormReturn<AgencyFormSchemaType>
  isDisabled?: boolean
}

export const AgencyFormSystemTab = ({
  form,
  isDisabled = false,
}: AgencyFormSystemTabProps): ReactNode => (
  <div className="space-y-4">
    <div className="agency-form-system-intro rounded-lg border bg-muted/50 p-4">
      <h3 className="font-medium">System Prompt</h3>
      <p className="mt-1 text-sm text-muted-foreground">
        This prompt will be injected into every agent and supervisor within this agency. Use it to
        set context, guidelines, and behavior for all AI interactions.
      </p>
    </div>

    <FormField
      control={form.control}
      name="systemPrompt"
      render={({ field }) => (
        <FormItem>
          <FormLabel>System Instructions</FormLabel>
          <FormControl>
            <MarkdownEditor
              initialValue={field.value}
              onChange={field.onChange}
              onBlur={() => field.onBlur()}
              placeholder="Enter system prompt instructions..."
              variant="full"
              toolbar="system-prompt"
              minHeight="400px"
              disabled={isDisabled}
              className="agency-form-system-prompt-editor"
            />
          </FormControl>
          <FormDescription>Supports headers, bold, italic, and separators</FormDescription>
          <FormMessage />
        </FormItem>
      )}
    />
  </div>
)

AgencyFormSystemTab.displayName = 'AgencyFormSystemTab'
